import { useEffect, useState } from "react";
import Button from "../Button/Button";
import "./styles.css";
import { UpdateUserInfoUrl } from "../../constants";
import { useTranslation } from "react-i18next";
import { InfoCollection } from "./InfoCollection";
import { useConfig } from "../../context/ConfigContext";
import { ThickCheckMarkIcon } from "../icons/ThickCheckMarkIcon";
import { CirclePulseAnimation } from "../animations/CirclePulseAnimation/CirclePulseAnimation";
import useSendEmail from "../../hooks/useSendEmail";

export const QuestionsModule = ({
  apiToken,
  fetchAIResults,
  runNextModule,
  onError,
}) => {
  const { t, i18n } = useTranslation("questionsModule");
  const [currentStep, setCurrentStep] = useState(0);

  const { addUserEmail, sendEmail } = useSendEmail();

  const [fetchResultsComplete, setFetchResultsComplete] = useState(false);
  const [isResultResponseSuccess, setIsResultResponseSuccess] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isSaveDone, setIsSaveDone] = useState(false);
  const { configData, userQuestions } = useConfig();

  const fetchResults = async () => {
    const resResponse = await fetchAIResults();
    if (resResponse) {
      setIsResultResponseSuccess(true);
    } else {
      setIsResultResponseSuccess(false);
    }
    setFetchResultsComplete(true);
  };

  useEffect(() => {
    fetchResults();
    const timerId = setTimeout(async () => {
      if (
        configData.QuestionsModuleFlags.emailEnabled ||
        userQuestions.length > 0
      ) {
        setCurrentStep(1);
      } else {
        setCurrentStep(2);
        setIsEmailSent(true);
        saveSelectedInfo({ lang: i18n.language });
      }
    }, 1500);
    return () => clearTimeout(timerId);
  }, []);

  useEffect(() => {
    if (currentStep === 2 && fetchResultsComplete && !isResultResponseSuccess) {
      onError();
    }
  }, [currentStep, fetchResultsComplete, isResultResponseSuccess, onError]);

  useEffect(() => {
    if (
      currentStep === 2 &&
      fetchResultsComplete &&
      isResultResponseSuccess &&
      !isEmailSent
    ) {
      if (configData.QuestionsModuleFlags.emailEnabled)
        sendEmail(i18n.language, apiToken);
      setIsEmailSent(true);
    }
  }, [
    i18n.language,
    apiToken,
    isEmailSent,
    currentStep,
    configData.QuestionsModuleFlags.emailEnabled,
    fetchResultsComplete,
    isResultResponseSuccess,
    sendEmail,
  ]);

  const saveSelectedInfo = async (userData) => {
    try {
      const res = await fetch(UpdateUserInfoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        body: JSON.stringify(userData),
      });
      if (!res.ok) {
        throw new Error("Unable to send Questionnaire data!");
      }
    } catch (error) {
      console.error("Error saving selected info:", error);
    }
    setIsSaveDone(true);
  };

  return (
    <div className="questions-module">
      {currentStep === 2 &&
      isEmailSent &&
      isSaveDone &&
      isResultResponseSuccess &&
      fetchResultsComplete ? (
        <div className="analyze-progress select-4-rows">
          <ThickCheckMarkIcon className="result-ready-animaton" />
          <h4 className="analyze-title-success">
            {t("results-success-title")}
          </h4>
          <p className="analyze-info-success">{t("results-ready")}</p>
        </div>
      ) : (
        <div
          className={`analyze-progress ${currentStep === 0 || currentStep === 2 ? "select-4-rows" : ""}`}
        >
          <CirclePulseAnimation />
          {currentStep !== 1 && (
            <p className="analyze-text-animated">{t("analyzing")}...</p>
          )}
        </div>
      )}
      {currentStep === 1 && (
        <InfoCollection
          updateEmail={addUserEmail}
          questionsData={userQuestions}
          onComplete={(data) => {
            setCurrentStep(2);
            saveSelectedInfo(data);
          }}
        />
      )}
      {currentStep === 2 &&
        isEmailSent &&
        isSaveDone &&
        isResultResponseSuccess &&
        fetchResultsComplete && (
          <div className="question-module-btn-wrapper-bottom">
            <Button text={t("continue")} onClick={() => runNextModule()} />
          </div>
        )}
    </div>
  );
};
